import React from "react";
import StaticHeader from "../../layout/header/StaticHeader";
import { TITLE_POSTFIX, TITLE_SEP } from "../DocumentTitle";
import { LoadErrorPage } from "./LoadErrorPage";

export default function NotFoundScreen() {
  return (
    <>
      <StaticHeader />
      <LoadErrorPage
        title={`404 ${TITLE_SEP} Finner ikke siden ${TITLE_POSTFIX}`}
      >
        <p>
          Siden du leter etter finnes ikke.
          <br />
          <br />
          Det kan være at siden rett og slett er utdatert eller at den har blitt
          flyttet.
          <br />
          Hvis du har fulgt en lenke fra SMS, sjekk at du brukte den siste du
          mottok.
        </p>
      </LoadErrorPage>
    </>
  );
}
